export default __webpack_public_path__ + "static/media/10.6f868fce.png";